import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-film-line text-xl text-background-50"></i>
              </span>
              <span className="font-heading text-xl font-extrabold text-background-50">妖精视频</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-100 max-w-md">
              妖精视频致力于为影视爱好者提供丰富多元的影视资源查询与观看推荐服务，
              覆盖最新电影、热门电视剧、精选综艺等多类别内容，帮助你更快发现想看的作品。
            </p>
            <p className="mt-4 text-xs text-primary-200/80">
              本站内容与图片均为演示用虚构示例，仅作展示用途，不含真实播放与下载接口。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50 mb-4 tracking-wide">内容导航</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/category/movie" className="text-primary-100 hover:text-accent-300 transition-colors">电影频道</Link></li>
              <li><Link to="/category/tv" className="text-primary-100 hover:text-accent-300 transition-colors">电视剧频道</Link></li>
              <li><Link to="/category/variety" className="text-primary-100 hover:text-accent-300 transition-colors">综艺频道</Link></li>
              <li><Link to="/search" className="text-primary-100 hover:text-accent-300 transition-colors">全站搜索</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50 mb-4 tracking-wide">联系我们</h3>
            <ul className="space-y-2.5 text-sm">
              <li className="flex items-center gap-2 text-primary-100">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-mail-line"></i></span>
                hello@yaojing-video.example
              </li>
              <li className="flex items-center gap-2 text-primary-100">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-customer-service-2-line"></i></span>
                400-000-0000
              </li>
              <li><Link to="/about" className="text-primary-100 hover:text-accent-300 transition-colors">关于我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-200/80">
          <span>© 2026 妖精视频 · 版权所有</span>
          <span>影视内容展示与推荐平台 · 仅供演示</span>
        </div>
      </div>
    </footer>
  );
}